namespace JupitersChoice {
    export class DoBaseGameLightningGlowOnReelsCmd {

        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;
        @inject('GameConfig') _config: Sapphire.GameConfig;
        @inject('GameServer') _gameServer: Sapphire.GameServer;
        @inject('ResponseHelper') _responseHelper: ResponseHelper;
        @inject('SoundManager') _soundManager: Sapphire.SoundManager;
        @inject('OrientationModel') _orientationModel: Sapphire.OrientationModel;

        execute(): void {
            const response: any = this._gameServer.logicResponse;
            const grids = this._config.get('external', 'grids');
            const reelsetType = grids[response.grid].reels;
            const reels = this._componentManager.get('Reels');
            const lockedReels = this._responseHelper.getLockedReels(response.lockedWithPreviousReel);

            for (let i = 0; i < 2; i++) {

                if(this._orientationModel.isPortrait){
                    let blt2 = this._componentManager.get(`PortraitBolt${lockedReels[i]}`);

                    blt2.reset();
                    blt2.setOnComplete(() => { blt2.hide(); });
                    blt2.play();
                }

                let blt = this._componentManager.get(`ReelGlow${lockedReels[i]}`);

                //blt.show();
                blt.play();
            }
            this._soundManager.play('lightning_03');
        }
    }
}